var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCandelier01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 7.5H36.25",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0312 7.5V42.446",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 35V29.375C11.25 24.1973 15.4473 20 20.625 20C25.8027 20 30 24.1973 30 29.375M30 29.375V30M30 29.375C30 24.1973 34.1973 20 39.375 20C44.5527 20 48.75 24.1973 48.75 29.375V35",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7802 41.382L45.765 35.691C45.9872 35.2675 46.4412 35 46.938 35H50.562C51.0587 35 51.5127 35.2675 51.735 35.691L54.7197 41.382C55.5915 43.0442 54.3237 45 52.3742 45H45.1257C43.1762 45 41.9085 43.0442 42.7802 41.382Z",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28025 41.382L8.26513 35.691C8.48723 35.2675 8.94128 35 9.43793 35H13.0621C13.5587 35 14.0128 35.2675 14.2349 35.691L17.2197 41.382C18.0916 43.0442 16.8236 45 14.8741 45H7.62585C5.67635 45 4.4084 43.0442 5.28025 41.382Z",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6418 48.675L27.134 43.0875C27.3625 42.722 27.763 42.5 28.194 42.5H31.8085C32.2392 42.5 32.64 42.722 32.8685 43.0875L36.3605 48.675C37.4012 50.34 36.2042 52.5 34.2405 52.5H25.7617C23.7982 52.5 22.6011 50.34 23.6418 48.675Z",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandelier01);
export default __webpack_public_path__ + "static/media/candelier-01.3b443684d5c591d9aaa1c146a7c29724.svg";
export { ForwardRef as ReactComponent };